module.exports = __webpack_public_path__ + "img/65756.7480463d.png";